import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUniversity, FaMicrophone, FaBriefcase } from "react-icons/fa";
import "./Speaker.css";

const Speakers = () => {
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSpeakers();
  }, []);

  const fetchSpeakers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/speakers`
      );
      setSpeakers(response.data);
      setError(null);
    } catch (error) {
      console.error("Error fetching speakers:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const renderSpeakerSection = (title, type) => {
    const filteredSpeakers = speakers.filter((s) => s.type === type);

    return (
      <div className="speaker-section">
        <div className="heading-container">
          <h4>{title}</h4>
        </div>
        <div className="speaker-grid">
          {filteredSpeakers.length > 0 ? (
            filteredSpeakers.map((speaker, index) => (
              <div key={index} className="speaker-card">
                {/* Left Side - Photo */}
                <div className="speaker-left-section">
                  <div className="img-container">
                    <img
                      className="speaker-image"
                      src={speaker.picture || '/default-avatar.jpg'}
                      alt={speaker.name}
                      onError={(e) => {
                        e.target.src = '/default-avatar.jpg';
                      }}
                    />
                  </div>
                </div>

                {/* Right Side - Details */}
                <div className="speaker-right-section">
                  <div className="speaker-details">
                    <h3 className="speaker-name">{speaker.name}</h3>
                    
                    <div className="speaker-position-wrapper">
                      <FaBriefcase className="position-icon" />
                      <p className="speaker-position">{speaker.position}</p>
                    </div>
                    
                    <div className="speaker-university-wrapper">
                      <FaUniversity className="university-icon" />
                      <p className="speaker-university">{speaker.university}</p>
                    </div>
                    
                    {speaker.title && (
                      <div className="talk-section">
                        <div className="talk-header">
                          <FaMicrophone className="talk-icon" />
                          <strong className="talk-label">Talk Title:</strong>
                        </div>
                        <p className="talk-title">{speaker.title}</p>
                      </div>
                    )}
                    
                    {speaker.abstract && (
                      <div className="abstract-section">
                        <strong className="abstract-label">Abstract:</strong>
                        <p className="speaker-abstract">{speaker.abstract}</p>
                      </div>
                    )}
                    
                    {speaker.website && (
                      <a 
                        href={speaker.website} 
                        className="speaker-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg className="link-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                        Visit Website
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-speakers-message">
              <div className="no-speakers-icon">👤</div>
              <p className="no-speakers-text">No {title.toLowerCase()} available at the moment.</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="speakers-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading speakers...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="speakers-container">
        <div className="error-container">
          <p className="error-message">Error loading speakers: {error}</p>
          <button onClick={fetchSpeakers} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="speakers-container">
      {renderSpeakerSection("Keynote Speakers", "KeynoteSpeaker")}
      {renderSpeakerSection("Invited Talks", "InvitedTalks")}
    </div>
  );
};

export default Speakers;